import React from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Solution1 from './Solution1';
import Solution2 from './Solution2';
import '../Usecases1.css';

const Esg = () => {
    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        if (location.pathname === '/esg') {
            navigate('step1');
        }
    }, [location, navigate]);

    return (
        <Routes>
            <Route path="step1" element={<Solution1 />} />
            <Route path="step2" element={<Solution2 />} />
            {/* Fallback route */}
            <Route path="*" element={<Solution1 />} />
        </Routes>
    );
};

export default Esg;
